import React from 'react';
import clsx from 'clsx';
import { Spinner } from '@heroui/spinner';

const ProtectPdfButton = ({
  variant = 'primary',
  type = 'button',
  isDisabled = false,
  isLoading = false,
  onClick,
  children,
}: {
  variant?: 'primary' | 'secondary';
  type?: 'button' | 'submit';
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={isDisabled || isLoading}
    aria-busy={isLoading}
    className={clsx(
      'flex h-12 w-full items-center justify-center gap-1 rounded-[5px] font-barlow text-[17px] font-medium leading-[normal] outline-none transition-colors',
      variant === 'primary'
        ? 'bg-[#4B7EFF] p-2 text-white enabled:hover:bg-primary-dark-blue'
        : 'border border-solid border-[#787887] bg-white px-8 py-2 text-[#454655] enabled:hover:bg-[#F7F7F9]',
      isDisabled && !isLoading && 'cursor-not-allowed opacity-40',
      isLoading && 'cursor-wait'
    )}
  >
    {isLoading ? <Spinner size="sm" color="white" /> : children}
  </button>
);

export default ProtectPdfButton;
